import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

/** the participant chip's static look, shared with the SMS To line */
export const participantChipSx = (theme: Theme): SystemStyleObject<Theme> => ({
  minWidth: '4rem',
  height: 'auto',
  padding: '0.125rem 0.2rem 0.125rem 0.375rem',
  cursor: 'pointer',
  fontSize: '0.75rem',
  borderRadius: '6px',
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainer,
  '& .MuiChip-label': { paddingLeft: '0', paddingRight: '0.1rem' },
  '& .MuiChip-deleteIcon': { margin: 0, fontSize: '1rem' },
});
